<template>
	<div style="overflow-y: auto">
		<v-container>
			<v-row
				:justify="$vuetify.breakpoint.lgAndDown ? 'space-between' : 'center'"
				align="center"
			>
				<v-col cols="12" sm="3">
					<v-img src="@/assets/lugares-1.png" width="150" class="mb-2 center"></v-img>
					<place-form-dialog />
				</v-col>
			</v-row>
		</v-container>
		<v-container>
			<v-row justify="center">
				<v-col cols="12">
					<v-skeleton-loader :loading="loading" height="94" type="list-item-two-line">
						<list-work-order />
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									outlined
									v-bind="attrs"
									x-small
									color="primary"
									class="ma-2 elevation-0"
									@click="fetchPlace"
									dark
								>
									<v-icon small>mdi-reload</v-icon>
									Refrescar lugares
								</v-btn>
							</template>
							<span>Refrescar establecimientos</span>
						</v-tooltip>
						<v-col cols="12" sm="4">
							Buscar establecimientos por nombre
							<v-text-field
								dense
								filled
								solo
								outlined
								hide-details
								append-icon="mdi-magnify"
								label="Nombre del establecimiento"
								@input="filter"
							></v-text-field>
							<v-img src="@/assets/lugares-2.png" width="80" class="mb-4"></v-img>
						</v-col>
						<place-list
							title="Establecimientos"
							msjnodata="No hay establecimientos para mostrar"
							:chipsList="chipsList"
							:myOwnedPlaces="myOwnedPlaces"
							:mySharedPlaces="mySharedPlaces"
							:onChangeChips="onChangeChips"
							:places="placeListFilter"
							:warningMessage="warningMessage"
						/>
					</v-skeleton-loader>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import filterDocumentMixin from '@/mixins/filterDocument.js';
import moment from 'moment';
import { isArray } from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
	name: 'Place',
	components: {
		PlaceList: () => import('@/components/place/PlaceList.vue'),
		PlaceFormDialog: () => import('@/components/place/PlaceFormDialog'),
		ListWorkOrder: () => import('@/components/place/ListWorkOrder.vue'),
	},
	mixins: [filterDocumentMixin],
	data() {
		return {
			placeListFilter: [],
			warningMessage: '',
			form: {
				name: '',
				rut: '',
				services: [],
			},
		};
	},
	computed: {
		chipsList() {
			return this.getLabelsPlaces(this.places);
		},
		myOwnedPlaces() {
			return this.placeListFilter.filter(
				place => place.ownerEmail === this.userProfile.email
			);
		},
		mySharedPlaces() {
			return this.placeListFilter.filter(
				place => place.ownerEmail !== this.userProfile.email
			);
		},
		...mapGetters({
			loading: 'User/globalLoading',
			places: 'Place/places',
			message: 'Place/message',
		}),
	},
	watch: {
		message(newVal) {
			this.snackbar({
				content: newVal.text,
				color: newVal.type,
			});
		},
		places(newVal) {
			this.placeListFilter = newVal;
		},
	},
	mounted() {
		this.placeListFilter = this.places;
	},
	methods: {
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		filter(word) {
			if (isArray(word)) {
				// filter place by documents
				const labelDefaultSelected = this.labelDefaultSelected(word);
				this.placeListFilter = this.places.filter(place => {
					return place.typeDocuments.some(typeDocument => {
						if (typeDocument) {
							const status =
								word.includes(typeDocument.done ? 'subido' : 'pendiente') ||
								word.includes(this.itsDue(typeDocument.date) && 'caducado');
							const text = word.some(
								item => typeDocument.text.toLowerCase().indexOf(item) > -1
							);
							if (labelDefaultSelected) return status && text;
							return text;
						}
					});
				});
			} else {
				this.placeListFilter = this.places.filter(
					place =>
						place.name.toLowerCase().indexOf(word.toLowerCase()) > -1 ||
						place.rut.toLowerCase().indexOf(word.toLowerCase()) > -1
				);
			}
		},
		onChangeChips(labels) {
			// clear warning message
			this.warningMessage = '';
			// return to the original state places
			if (!labels.length) return (this.placeListFilter = this.places);
			// set warning message if empty document selected
			if (!this.labelSelected(labels))
				return (this.warningMessage = 'Falta seleccionar el documento a filtrar');
			this.filter(labels);
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
		}),
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style lang="scss">
.center {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
</style>
